<template>
  <div>
    <div class="publish">
      <span class="askmarket" @click="askShow">问行情</span>
<!--      <span class="shares" @click="sharesShow">诊股票</span>-->
      <input type="text" v-model="comment" v-reset-page class="question" placeholder="输入股票代码">
      <span @click='send' class="submit1 speak">发送</span>
    </div>
    <!--遮罩层-->
    <div class="layer" v-if="dialogshow"></div>
    <!--问行情弹框-->
    <div class="askmarket_detail" v-if="askmarketshow">
      <p class="title">问行情</p>
      <div v-for="item in questions">
        <p class="option" @click="ask(item.question,1)">{{item.question}}</p>
      </div>
      <p class="close">
        <img :src="closeImg" @click="hide(2)">
      </p>
    </div>
    <!--诊股票弹框-->
<!--    <div class="consultation_stock" v-if="stockShow">-->
<!--      <p class="title">诊股票</p>-->
<!--      <p class="option" v-for="item in shares" @click="fillInCode(item.txt,item.id)">{{item.txt}}</p>-->
<!--      <p class="close">-->
<!--        <img :src="closeImg" @click="hide(2)">-->
<!--      </p>-->
<!--    </div>-->
    <!--填写股票代码弹框-->
<!--    <div class="fillIn" v-if="fillShow">-->
<!--      <p class="title">诊股票</p>-->
<!--      <p class="option">{{ question }}</p>-->
<!--      <p class="input" v-if="id===3">-->
<!--        <input type="tel" v-reset-page v-model.trim="buyprice" placeholder="请输入买入价格">-->
<!--      </p>-->
<!--      <p class="input">-->
<!--        <input type="text" v-reset-page v-model.trim="stockcode" placeholder="请输入股票代码">-->
<!--      </p>-->
<!--      <p class="btn">-->
<!--        <span class="previous" @click="lastStep">上一步</span>-->
<!--        <span class="sendcode" @click="tijiao()">发送</span>-->
<!--      </p>-->
<!--      <p class="close">-->
<!--        <img :src="closeImg" @click="hide(2)">-->
<!--      </p>-->
<!--    </div>-->
  </div>
</template>

<script>
import * as api from "../../../api/api"
export default {
  name: "Question",
  props: ['user'],
  data() {
    return {
      rid: 4,
      id: '',
      comment: '',
      closeImg: 'https://yuanda-live.oss-cn-beijing.aliyuncs.com/zbj/files/images/close.png',
      questions: [],
      dialogshow: false,
      askmarketshow: false,
      stockShow: false,
      question: '',
      stockcode: '',
      buyprice: '',
      fillShow: false,
      shares: [
        {
          'id': 1,
          'txt': '短期走势'
        },
        {
          'id': 2,
          'txt': '能不能买入'
        },
        {
          'id': 3,
          'txt': '应如何操作'
        }
      ]
    }
  },
  directives: {
    resetPage: {
      inserted: function (el) {
        document.body.addEventListener('focusout', () => {
          if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            //软键盘收起的事件处理
            setTimeout(() => {
              const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
              window.scrollTo(0, Math.max(scrollHeight - 1, 0));
            }, 100)
          }
        });
      }
    }
  },
  mounted() {
    this.getQuestion()
    this.setHeight()
  },
  methods: {
    getQuestion() {
      this.axios.get(api.QuestionList + this.rid).then( res => {
        this.questions = res.data.data
      })
    },
    sharesShow: function () {
      this.dialogshow = true;
      this.stockShow = true;
      $('.zbj').css('margin-top', '-4.4rem')
    },
    hide: function () {
      this.question = '';
      this.stockcode = '';
      this.buyprice = '';
      this.dialogshow = false;
      this.askmarketshow = false;
      this.stockShow = false;
      this.fillShow = false;
      $('.zbj').css('margin-top', '0')

    },
    fillInCode: function (txt, id) {
      this.question = txt;
      this.id = id;
      this.stockShow = false;
      this.fillShow = true;
    },
    lastStep: function () {
      this.fillShow = false;
      this.stockShow = true;
      //清空输入框中的数据
      this.question = '';
      this.stockcode = '';
      this.buyprice = '';
    },
    /*行情问题提问*/
    ask: function (question) {
      const username = this.user.nickname;
      const nickname = this.user.nickname;
      this.$http.post(api.CHAT, {
        question: question,
        username: username,
        nickname: nickname,
        type: 'hq',
        code: '',
        head: '',
        rid: this.rid
      }).then(function (res) {
        if (res.data.code !== 1000) {
          this.$dialog.toast({mes: res.data.message, timeout: 1500});
          //清空输入框中的数据
          this.stockcode = '';
          this.buyprice = '';
          return;
        } else {
          this.hide();  //关闭弹窗
          //清空输入框中的数据
          this.stockcode = '';
          this.buyprice = '';
        }
      })
    },
    /*诊股票*/
    tijiao: function () {
      var str = '';
      var question = this.question;
      var code = this.stockcode;
      var money = this.buyprice;
      if (code.length === 0) {
        this.$dialog.toast({mes: "输入框不能为空", timeout: 1500});
        return;
      }
      if (this.id === 3) {
        if (money.length === 0) {
          this.$dialog.toast({mes: "输入框不能为空", timeout: 1500});
          return;
        }
        if (!$.isNumeric(money)) {
          this.$dialog.toast({mes: "股票价格格式不正确", timeout: 1500});
          this.stockcode = '';
          this.buyprice = '';
          return false;
        }
      }
      if (money) {
        str = money + "元买入" + code + question;
      } else {
        console.log(this.id)
        if (this.id === 1){
          str = code + "的" + question;
        }else{
          str = code + question;
        }
      }
      var username = this.user.nickname;
      var nickname = this.user.nickname;
      this.$http.post(api.CHAT, {
        question: str,
        username: username,
        nickname: nickname,
        type: 'zgp',
        code: code,
        head: '',
        rid: this.rid
      }).then(function (res) {
        if (res.data.code !== 1000) {
          this.$dialog.toast({mes: res.data.message, timeout: 1500});
          //清空输入框中的数据
          this.stockcode = '';
          this.buyprice = '';
        } else {
          this.hide();  //关闭弹窗
        }
      })
    },
    /*发送消息*/
    send: function () {
      /*防止重复提交*/
      if (!$('.submit1').hasClass('speak')) {
        return false;
      }
      $('.submit1').removeClass('speak');
      var question = this.comment;
      var username = this.user.nickname;
      var nickname = this.user.nickname;
      var type = 'ask'

      if ($.trim(question).length === 0) {
        this.$dialog.toast({mes: "输入框不能为空", timeout: 1500});
        $('.submit1').addClass('speak');
        return;
      }
      this.$http.post(api.CHAT, {
        question: question,
        username: username,
        nickname: nickname,
        type: type,
        code: '',
        head: '',
        rid: this.rid,
      }).then(function (res) {
        if (res.data.code !== 1000) {
          this.$dialog.toast({mes: res.data.message, timeout: 1500});
          $('.submit1').addClass('speak');
          this.comment = '';
          return;
        }
        $('.submit1').addClass('speak');
        this.comment = '';
      })
    },
    //为屏幕设置高度
    setHeight: function () {
      var totalheight = parseFloat($(window).height());
      var headerheight = parseFloat($('.navtab').height());
      var homeheight = totalheight - headerheight
      $('.home').height(homeheight);
      var videoheight = parseFloat($('.zbj').height());
      var tabheigt = parseFloat($('.tab').height());
      var live = $('#liveprompt').hasClass('active');
      if (!live) {
        var commentheight = homeheight - videoheight - tabheigt;
      } else {
        var liveheight = parseFloat($('.liveprompt').height());
        var commentheight = homeheight - videoheight - tabheigt - liveheight;
      }
      $('.comment').height(commentheight);
      $('.program').height(commentheight);
    },
    askShow: function () {
      $('.zbj').css('margin-top', '-4.4rem')
      //获取设置的行情问题列表
      this.axios.get(api.GETQUESTIONS + this.rid).then(res => {
        this.questions = res.data.data
      })
      this.dialogshow = true;
      this.askmarketshow = true;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/zb/components/Question.vue